import { FC } from "react";

interface Props {
  message: string;
}

/** The empty/hint line shared by all tables; callers decide when it shows. */
export const TableEmptyState: FC<Props> = ({ message }) => (
  <p className="px-4 py-6 text-center text-body-base font-semibold leading-md text-foreground-secondary">
    {message}
  </p>
);
